import { render, staticRenderFns } from "./ProfileAbout.vue?vue&type=template&id=6707c0fc&scoped=true"
import script from "./ProfileAbout.vue?vue&type=script&lang=ts"
export * from "./ProfileAbout.vue?vue&type=script&lang=ts"
import style0 from "./ProfileAbout.vue?vue&type=style&index=0&id=6707c0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707c0fc",
  null
  
)

export default component.exports